module.exports = __webpack_public_path__ + "img/proj3.5eeaf919.png";